export default __webpack_public_path__ + "static/Vent Construction-fe3f2f73bdd4d797cf3fa20fb7eb07a2.jpg";